import {
  CC_ESTIMATE_SAVE_REQUEST,
  CC_ESTIMATE_SAVE_SUCCESS,
  CC_ESTIMATE_SAVE_FAILED,
  CC_ESTIMATE_LOAD_REQUEST,
  CC_ESTIMATE_LOAD_SUCCESS,
  CC_ESTIMATE_LOAD_FAILED,
  CC_ESTIMATE_STATE_CHANGE,
  CC_SCOPE_PHOTO_UPLOAD_REQUEST,
  CC_SCOPE_PHOTO_UPLOAD_SUCCESS,
  CC_SCOPE_PHOTO_UPLOAD_FAILED,
  CC_SCOPES_REQUEST,
  CC_SCOPES_SUCCESS,
  CC_SCOPES_FAILED,
} from "../../../_utils/constants/CountertopCabinetEstimate";

const initialState = {
  estimate: null,
  isSaving: false,
  isSaved: false,
  isLoading: false,
  isLoaded: false,
  errors: {},
  isUploadingPhoto: false,
  uploadingScopeBlockId: null,
  lastUploadedPhoto: null,
  photoUploadError: null,
  scopes: [],
  isScopesLoading: false,
  isScopesLoaded: false,
};

const CountertopCabinetEstimateReducer = (state = initialState, action) => {
  switch (action.type) {
    case CC_ESTIMATE_SAVE_REQUEST:
      return { ...state, isSaving: true, isSaved: false, errors: {} };
    case CC_ESTIMATE_SAVE_SUCCESS:
      return { ...state, isSaving: false, isSaved: true, estimate: action.payload, errors: {} };
    case CC_ESTIMATE_SAVE_FAILED:
      return { ...state, isSaving: false, isSaved: false, errors: action.payload || {} };

    case CC_ESTIMATE_LOAD_REQUEST:
      return { ...state, isLoading: true, isLoaded: false, errors: {} };
    case CC_ESTIMATE_LOAD_SUCCESS:
      return { ...state, isLoading: false, isLoaded: true, estimate: action.payload, errors: {} };
    case CC_ESTIMATE_LOAD_FAILED:
      return { ...state, isLoading: false, isLoaded: false, errors: action.payload || {} };

    case CC_ESTIMATE_STATE_CHANGE:
      return { ...state, [action.key]: action.value };

    case CC_SCOPES_REQUEST:
      return { ...state, isScopesLoading: true, isScopesLoaded: false };
    case CC_SCOPES_SUCCESS:
      return { ...state, isScopesLoading: false, isScopesLoaded: true, scopes: action.payload?.result || [] };
    case CC_SCOPES_FAILED:
      return { ...state, isScopesLoading: false, isScopesLoaded: false };

    case CC_SCOPE_PHOTO_UPLOAD_REQUEST:
      return { ...state, isUploadingPhoto: true, uploadingScopeBlockId: action.scopeBlockId, photoUploadError: null };
    case CC_SCOPE_PHOTO_UPLOAD_SUCCESS:
      return { ...state, isUploadingPhoto: false, uploadingScopeBlockId: null, lastUploadedPhoto: action.payload };
    case CC_SCOPE_PHOTO_UPLOAD_FAILED:
      return { ...state, isUploadingPhoto: false, uploadingScopeBlockId: null, photoUploadError: action.payload || {} };

    default:
      return state;
  }
};

export default CountertopCabinetEstimateReducer;
